const routes = [
  {
    path: '/docs',
    component: async () => import('@/pages/help/publisher/DocumentationPublisherWelcome.vue'),
    name: 'Docs - Publishers',
  },
  {
    path: '/docs/admin',
    component: async () => import('@/pages/help/admin/DocumentationAdminWelcome.vue'),
    name: 'Docs - Admin',
  },
  {
    path: '/docs/maintenance',
    component: async () => import('@/pages/help/maintenance/DocumentationMaintenanceWelcome.vue'),
    name: 'Docs - Maintenance',
  },
  {
    path: '/docs/admin/initial-setup',
    component: async () => import('@/pages/help/admin/DocumentationAdminInitialSetup.vue'),
    name: 'Docs - Admin - Initial Setup',
  },
  {
    path: '/docs/admin/ministry-management/schedule',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminSchedule.vue'),
    name: 'Docs - Admin - Schedule',
    meta: {
      permission: [
        'manage_shifts',
        'view_all_shifts',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/currentneeds',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminCurrentNeeds.vue'),
    name: 'Docs - Admin - Current Needs',
  },
  {
    path: '/docs/admin/ministry-management/experiences',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminExperiences.vue'),
    name: 'Docs - Admin - Experiences',
  },
  {
    path: '/docs/admin/ministry-management/day-overseers',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminDayLocationOverseer.vue'),
    name: 'Docs - Admin - Day Overseers',
  },
  {
    path: '/docs/admin/ministry-management/shift-plan',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminShiftPlan.vue'),
    name: 'Docs - Admin - Shift Plan',
  },
  {
    path: '/docs/admin/ministry-management/shift-tags',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminShiftTags.vue'),
    name: 'Docs - Admin - Shift Tags',
    meta: {
      permission: [
        'manage_shift_tags',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/locations',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminLocations.vue'),
    name: 'Docs - Admin - Locations',
    meta: {
      permission: [
        'manage_locations',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/stores',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminStores.vue'),
    name: 'Docs - Admin - Stores',
    meta: {
      permission: [
        'manage_stores',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/publications',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminPublications.vue'),
    name: 'Docs - Admin - Publications',
    meta: {
      permission: [
        'manage_publications',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/carts',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminCarts.vue'),
    name: 'Docs - Admin - Carts',
    meta: {
      permission: [
        'manage_cart',
      ],
    },
  },
  {
    path: '/docs/admin/ministry-management/timebands',
    component: async () => import('@/pages/help/admin/ministry-management/DocumentationAdminTimeBands.vue'),
    name: 'Docs - Admin - Time Bands',
    meta: {
      permission: [
        'manage_time_bands',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/publishers',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminPublishers.vue'),
    name: 'Docs - Admin - Publishers',
    meta: {
      permission: [
        'manage_users',
        'view_user_details',
        'manage_circuit_users',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/congregations',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminCongregations.vue'),
    name: 'Docs - Admin - Congregations',
    meta: {
      permission: [
        'manage_congregations',
        'manage_circuit_congregations',

      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/circuits',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminCircuits.vue'),
    name: 'Docs - Admin - Circuits',
    meta: {
      permission: [
        'manage_circuits',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/teams',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminTeams.vue'),
    name: 'Docs - Admin - Teams',
    meta: {
      permission: [
        'manage_teams',
        'view_teams-details',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/training',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminTraining.vue'),
    name: 'Docs - Admin - Training',
    meta: {
      permission: [
        'manage_course_sessions',
        'manage_courses',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/bulk-import',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminBulkImport.vue'),
    name: 'Docs - Admin - Bulk Import',
    meta: {
      permission: [
        'import_users',
      ],
    },
  },
  {
    path: '/docs/admin/publisher-management/rating-labels',
    component: async () => import('@/pages/help/admin/publisher-management/DocumentationAdminRatingLabels.vue'),
    name: 'Docs - Admin - Rating Labels',
    meta: {
      permission: [
        'manage_user_rating_labels',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/reports',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminReports.vue'),
    name: 'Docs - Admin - Reports',
    meta: {
      permission: [
        'manage_reports',
        'access_reports',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/documents',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminDocuments.vue'),
    name: 'Docs - Admin - Documents',
    meta: {
      permission: [
        'manage_documents',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/taskcategories',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminTaskCategories.vue'),
    name: 'Docs - Admin - Task Categories',
    meta: {
      permission: [
        'manage_task_categories',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/contact-options',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminContactOptions.vue'),
    name: 'Docs - Admin - Contact Options',
    meta: {
      permission: [
        'manage_contact_message_options',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/cancellation-reasons',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminCancellationReasons.vue'),
    name: 'Docs - Admin - Cancellation Reasons',
    meta: { permission: 'manage_shift_cancellation_reasons' },
  },
  {
    path: '/docs/admin/site-management/news',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminNews.vue'),
    name: 'Docs - Admin - News',
    meta: {
      permission: [
        'manage_news',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/alerts',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminAlerts.vue'),
    name: 'Docs - Admin - Alerts',
    meta: {
      permission: [
        'manage_alert_messages',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/faqs',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminFAQs.vue'),
    name: 'Docs - Admin - FAQs',
    meta: {
      permission: [
        'manage_faqs',
      ],
    },
  },
  {
    path: '/docs/admin/site-management/videos',
    component: async () => import('@/pages/help/admin/site-management/DocumentationAdminVideos.vue'),
    name: 'Docs - Admin - Videos',
    meta: {
      permission: [
        'manage_videos',
      ],
    },
  },
  {
    path: '/docs/admin/settings/settings',
    component: async () => import('@/pages/help/admin/settings/DocumentationAdminSettings.vue'),
    name: 'Docs - Admin - Settings',
    meta: {
      permission: ['manage_settings'],
    },
  },
  {
    path: '/docs/admin/settings/roles',
    component: async () => import('@/pages/help/admin/settings/DocumentationAdminRoles.vue'),
    name: 'Docs - Admin - Roles',
    meta: {
      permission: [
        'manage_roles',
        'assign_roles',
        'assign_any_role',
      ],
    },
  },
  {
    path: '/docs/admin/settings/languages',
    component: async () => import('@/pages/help/admin/settings/DocumentationAdminLanguages.vue'),
    name: 'Docs - Admin - Languages',
    meta: {
      permission: ['manage_languages'],
    },
  },
  {
    path: '/docs/admin/maintenance/system-info',
    component: async () => import('@/pages/help/admin/maintenance/DocumentationAdminSystemInfo.vue'),
    name: 'Docs - Admin - System Information',
    meta: {
      permission: [
        'access_system_monitor',
      ],
    },
  },
  {
    path: '/docs/admin/maintenance/system-monitor-dashboard',
    component: async () => import('@/pages/help/admin/maintenance/DocumentationAdminSystemMonitorDashboard.vue'),
    name: 'Docs - Admin - System Monitor/Dashboard',
    meta: {
      permission: [
        'access_system_monitor',
      ],
    },
  },
  {
    path: '/docs/publisher/managing-shifts/my-shifts',
    component: async () => import('@/pages/help/publisher/managing-shifts/DocumentationPublisherMyShifts.vue'),
    name: 'Docs - Publishers - My Shifts',
  },
  {
    path: '/docs/publisher',
    component: async () => import('@/pages/help/publisher/DocumentationPublisherWelcome.vue'),
    name: 'Docs - Publishers',
  },
  {
    path: '/docs/publisher/starting/my-details',
    component: async () => import('@/pages/help/publisher/starting/DocumentationPublisherMyDetails.vue'),
    name: 'Docs - Publishers - My Details',
  },
  {
    path: '/docs/publisher/before-shifts/news',
    component: async () => import('@/pages/help/publisher/before-shifts/DocumentationPublisherNews.vue'),
    name: 'Docs - Publishers - News',
  },
  {
    path: '/docs/publisher/before-shifts/my-tasks',
    component: async () => import('@/pages/help/publisher/before-shifts/DocumentationPublisherMyTasks.vue'),
    name: 'Docs - Publishers - My Tasks',
  },
  {
    path: '/docs/publisher/before-shifts/current-carts',
    component: async () => import('@/pages/help/publisher/before-shifts/DocumentationPublisherCurrentCarts.vue'),
    name: 'Docs - Publishers - Current Carts',
  },
  {
    path: '/docs/publisher/before-shifts/day-overseers',
    component: async () => import('@/pages/help/publisher/before-shifts/DocumentationPublisherDayOverseers.vue'),
    name: 'Docs - Publishers - Day Overseers',
  },
  {
    path: '/docs/publisher/before-shifts/location-overseers',
    component: async () => import('@/pages/help/publisher/before-shifts/DocumentationPublisherLocationOverseers.vue'),
    name: 'Docs - Publishers - Location Overseers',
  },
  {
    path: '/docs/publisher/after-shifts/contact-us',
    component: async () => import('@/pages/help/publisher/after-shifts/DocumentationPublisherContactUs.vue'),
    name: 'Docs - Publishers - Contact Us',
  },
  {
    path: '/docs/publisher/after-shifts/experiences',
    component: async () => import('@/pages/help/publisher/after-shifts/DocumentationPublisherExperiences.vue'),
    name: 'Docs - Publishers - Experiences',
  },
  {
    path: '/docs/publisher/managing-shifts/current-needs',
    component: async () => import('@/pages/help/publisher/managing-shifts/DocumentationPublisherCurrentNeeds.vue'),
    name: 'Docs - Publishers - Current Needs',
  },
  {
    path: '/docs/publisher/managing-shifts/calendar',
    component: async () => import('@/pages/help/publisher/managing-shifts/DocumentationPublisherMyCalendar.vue'),
    name: 'Docs - Publishers - Calendar',
  },
  {
    path: '/docs/publisher/managing-shifts/availability',
    component: async () => import('@/pages/help/publisher/managing-shifts/DocumentationPublisherSubmitAvailability.vue'),
    name: 'Docs - Publishers - Availability',
  },
  {
    path: '/docs/publisher/managing-shifts/locations',
    component: async () => import('@/pages/help/publisher/managing-shifts/DocumentationPublisherLocations.vue'),
    name: 'Docs - Publishers - Locations',
  },
  {
    path: '/docs/maintenance/initial-setup',
    component: async () => import('@/pages/help/maintenance/DocumentationMaintenanceInitialSetup.vue'),
    name: 'Docs - Maintenance - Initial Setup',
  },
  {
    path: '/docs/maintenance/obtain-domain',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceObtainDomain.vue'),
    name: 'Docs - Maintenance - Obtain a Domain Name',
  },
  {
    path: '/docs/maintenance/aws-rds-setup',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceAWSRDSSetup.vue'),
    name: 'Docs - Maintenance - AWS RDS Setup',
  },
  {
    path: '/docs/maintenance/aws-ec2-setup',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceAWSEC2Setup.vue'),
    name: 'Docs - Maintenance - AWS EC2 Setup',
  },
  {
    path: '/docs/maintenance/application-install',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceApplicationInstall.vue'),
    name: 'Docs - Maintenance - Application Install',
  },
  {
    path: '/docs/maintenance/aws-s3-setup',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceAWSS3Setup.vue'),
    name: 'Docs - Maintenance - AWS S3 Setup',
  },
  {
    path: '/docs/maintenance/outbound-email-setup',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenanceOutboundEmailSetup.vue'),
    name: 'Docs - Maintenance - Outbound Email Setup',
  },
  {
    path: '/docs/maintenance/post-install-configuration',
    component: async () => import('@/pages/help/maintenance/installation/DocumentationMaintenancePostInstallConfig.vue'),
    name: 'Docs - Maintenance - Post-Install Configuration',
  },
  {
    path: '/docs/maintenance/google-maps-integration',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceGoogleMaps.vue'),
    name: 'Docs - Maintenance - Google Maps Integration',
  },
  {
    path: '/docs/maintenance/openweathermap-integration',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceOpenWeatherMap.vue'),
    name: 'Docs - Maintenance - OpenWeatherMap Integration',
  },
  {
    path: '/docs/maintenance/google-authentication-setup',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceGoogleAuth.vue'),
    name: 'Docs - Maintenance - Google Authentication Setup',
  },
  {
    path: '/docs/maintenance/google-contacts-integration',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceGoogleContacts.vue'),
    name: 'Docs - Maintenance - Google Contacts Integration',
  },
  {
    path: '/docs/maintenance/google-calendar-integration',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceGoogleCalendar.vue'),
    name: 'Docs - Maintenance - Google Calendar Integration',
  },
  {
    path: '/docs/maintenance/google-drive-integration',
    component: async () => import('@/pages/help/maintenance/integration/DocumentationMaintenanceGoogleDrive.vue'),
    name: 'Docs - Maintenance - Google Drive Integration',
  },
  {
    path: '/docs/maintenance/updating',
    component: async () => import('@/pages/help/maintenance/ongoing/DocumentationMaintenanceUpdating.vue'),
    name: 'Docs - Maintenance - Update LSM',
  },
  {
    path: '/docs/maintenance/update-aws-rds',
    component: async () => import('@/pages/help/maintenance/ongoing/DocumentationMaintenanceUpdateAWSRDS.vue'),
    name: 'Docs - Maintenance - Update AWS RDS',
  },
  {
    path: '/docs/maintenance/background-tasks',
    component: async () => import('@/pages/help/maintenance/miscellaneous/DocumentationMaintenanceBackgroundTasks.vue'),
    name: 'Docs - Maintenance - Background Tasks',
  },
  {
    path: '/docs/glossary',
    component: async () => import('@/pages/help/Glossary.vue'),
    name: 'Docs - Glossary',
  },
];

export default routes;
